import '@angular/compiler';
import { PortalNrichadminAdminPipelineComponent } from './portal.nrichadmin.admin.pipeline/portal.nrichadmin.admin.pipeline.component';
import { PortalNrichadminAdminDashboardComponent } from './portal.nrichadmin.admin.dashboard/portal.nrichadmin.admin.dashboard.component';
import { PortalNrichCanvasPdfComponent } from './portal.nrich.canvas.pdf/portal.nrich.canvas.pdf.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { LayoutViewerComponent } from './layout.viewer/layout.viewer.component';
import { PortalNrichChatInputComponent } from './portal.nrich.chat.input/portal.nrich.chat.input.component';
import { PortalNrichCanvasTextComponent } from './portal.nrich.canvas.text/portal.nrich.canvas.text.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalNrichDividerComponent } from './portal.nrich.divider/portal.nrich.divider.component';
import { PortalNrichChatActivityComponent } from './portal.nrich.chat.activity/portal.nrich.chat.activity.component';
import { PortalNrichadminAdminTermsComponent } from './portal.nrichadmin.admin.terms/portal.nrichadmin.admin.terms.component';
import { PortalNrichCanvasPanelComponent } from './portal.nrich.canvas.panel/portal.nrich.canvas.panel.component';
import { PortalNrichadminAdminQuerylogComponent } from './portal.nrichadmin.admin.querylog/portal.nrichadmin.admin.querylog.component';
import { PageMainComponent } from './page.main/page.main.component';
import { PortalNrichCanvasThumbnailsComponent } from './portal.nrich.canvas.thumbnails/portal.nrich.canvas.thumbnails.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { LayoutPublicComponent } from './layout.public/layout.public.component';
import { LayoutAdminComponent } from './layout.admin/layout.admin.component';
import { PortalNrichadminAdminModelsComponent } from './portal.nrichadmin.admin.models/portal.nrichadmin.admin.models.component';
import { PortalNrichFooterComponent } from './portal.nrich.footer/portal.nrich.footer.component';
import { PortalNrichHeaderViewerComponent } from './portal.nrich.header.viewer/portal.nrich.header.viewer.component';
import { PortalNrichadminAdminVerifyComponent } from './portal.nrichadmin.admin.verify/portal.nrichadmin.admin.verify.component';
import { PageDocumentItemComponent } from './page.document.item/page.document.item.component';
import { PortalNrichNavAdminComponent } from './portal.nrich.nav.admin/portal.nrich.nav.admin.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalNrichChatPanelComponent } from './portal.nrich.chat.panel/portal.nrich.chat.panel.component';
import { PortalNrichChatMessageComponent } from './portal.nrich.chat.message/portal.nrich.chat.message.component';
import { PortalNrichadminAdminSettingsComponent } from './portal.nrichadmin.admin.settings/portal.nrichadmin.admin.settings.component';
import { PortalNrichCanvasImagesComponent } from './portal.nrich.canvas.images/portal.nrich.canvas.images.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { PageSearchComponent } from './page.search/page.search.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageAdminComponent } from './page.admin/page.admin.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalNrichadminAdminReviewComponent } from './portal.nrichadmin.admin.review/portal.nrichadmin.admin.review.component';
import { PortalNrichHeaderPublicComponent } from './portal.nrich.header.public/portal.nrich.header.public.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalNrichCanvasKgComponent } from './portal.nrich.canvas.kg/portal.nrich.canvas.kg.component';
import { PortalNrichadminAdminTokensComponent } from './portal.nrichadmin.admin.tokens/portal.nrichadmin.admin.tokens.component';

const INDEX_PAGE = "dashboard";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutPublicComponent,
        "children": [
            {
                "path": "",
                component: PageMainComponent,
                "app_id": "page.main"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "search",
                component: PageSearchComponent,
                "app_id": "page.search"
            }
        ]
    },
    {
        component: LayoutViewerComponent,
        "children": [
            {
                "path": "document/:id",
                component: PageDocumentItemComponent,
                "app_id": "page.document.item"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "login",
                component: PageLoginComponent,
                "app_id": "page.login"
            }
        ]
    },
    {
        component: LayoutAdminComponent,
        "children": [
            {
                "path": "admin/:tab?",
                component: PageAdminComponent,
                "app_id": "page.admin"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }